import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from './en.json';
import de from './de.json';
import hr from './hr.json';
import tr from './tr.json';
import sq from './sq.json';

i18n
    .use(initReactI18next)
    .init({
        fallbackLng: "de",
        debug: false,
        returnObjects: true,
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                translation: en,
            },
            de: {
                translation: de
            },
            hr: {
                translation: hr
            },
            tr: {
                translation: tr
            },
            sq: {
                translation: sq
            },
        },
    });
